module.exports = __webpack_public_path__ + "img/1440.0500dd5f.jpg";